/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import { Slider } from 'primereact/slider';

export const SliderRangeWidget: React.FC<WidgetProps> = (props) => {
  const { value, schema } = props;

  const showValue = value ?? [schema.minimum, schema.maximum];

  return (
    <div className="w-full flex flex-column">
      <label className="ms-Label capitalize font-semibold text-sm">{schema.title}</label>
      <div className={'flex align-items-center mt-3 mb-2 justify-content-between'}>
        <Slider
          value={value}
          min={schema.minimum ?? 0}
          max={schema.maximum ?? 100}
          onChange={(e) => {
            props.onChange(e.value);
          }}
          className=" w-10"
          range
        />
        <div className="w-1 text-right">
          <code>{JSON.stringify(showValue)}</code>
        </div>
      </div>
    </div>
  );
};
